export const excludeParlors = [
  "",
  // "76",
  // "194",
  // "229",
  // "247",
  // "262",
  // "325",
  // "326",
  // "402",
  // "585",
  // "595",
  // "611",
  // "641",
  // "792",
  // "833",
  // "863",
  // "996",
];

// 공설/일부 대학병원 장례식장 (오인지 유도 가능)
export const safeParlorIds = [
  129, 270, 203, 264, 576, 584, 289, 27, 200, 214, 469, 52, 840, 77, 22, 506, 58, 94, 560, 157, 167,
  168, 573, 169, 257, 204, 249, 441, 260, 13, 879, 658, 615, 621, 687, 357, 995, 1001, 1006, 674,
  1019, 1188, 1043, 1026,
];
